var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 11,
    viewBox: "0 0 16 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.9939 0.737987C15.2679 1.01071 15.2689 1.45393 14.9962 1.72793L6.84541 9.91696C6.1627 10.6029 5.10621 10.6065 4.41956 9.9278L1.02373 6.77451C0.740438 6.51145 0.724035 6.06854 0.987098 5.78524C1.25016 5.50195 1.69307 5.48554 1.97637 5.74861L5.38113 8.91019C5.38785 8.91644 5.39446 8.92282 5.40094 8.92933C5.54001 9.06905 5.71408 9.06905 5.85315 8.92933L14.0039 0.740304C14.2766 0.466298 14.7199 0.46526 14.9939 0.737987Z",
    fill: "#353570"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.eab7b6c4ed3d4c22280d9ef0f54eb887.svg";
export { ForwardRef as ReactComponent };